import styled, { css } from 'styled-components'
import { getBasePath } from '../../utils/miscellaneous-utils'
import { zIndexScale } from '../../utils/style-utils'

const whiteCheckUrl = `url(${getBasePath('/assets/icons/white-check.svg')})`

export const CheckboxTooltip = styled.span(
    ({ theme }) => css`
        position: absolute;
        top: calc(100% + 0.5rem);
        right: 0;
        z-index: ${zIndexScale.largeTags.medium};
        width: 13rem;
        max-width: 80vw;
        padding: ${theme.spacing.small};
        border-radius: ${theme.typography.border.radius.medium};
        background-color: ${theme.colors.tfwBlack99};
        color: ${theme.colors.white};
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.xSmall};
        font-weight: ${theme.typography.font.lato.weight.regular};
        line-height: 1.125rem;
        text-align: center;
        white-space: normal;
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        transition:
            opacity 0.15s ease-in-out,
            visibility 0.15s ease-in-out;

        &::after {
            content: '';
            position: absolute;
            bottom: 100%;
            right: 0.75rem;
            border-width: 0.375rem;
            border-style: solid;
            border-color: transparent transparent ${theme.colors.tfwBlack99} transparent;
        }
    `,
)

export const SelectBox = styled.span<{ $disabled?: boolean }>(
    ({ theme, $disabled }) => css`
        box-sizing: border-box;
        display: inline-block;
        width: 1.125rem;
        height: 1.125rem;
        border: 1.5px solid ${theme.colors.tfwDefaultInputBorder};
        border-radius: ${theme.typography.border.radius.xSmall};
        background-color: ${theme.colors.white};
        background-repeat: no-repeat;
        background-position: center;
        background-size: 0.75rem;
        flex-shrink: 0;
        opacity: ${$disabled ? 0.4 : 1};
        transition:
            background-color 0.15s ease-in-out,
            border-color 0.15s ease-in-out;
    `,
)

export const SelectInput = styled.input(
    ({ theme }) => css`
        display: none;

        &:checked + ${SelectBox} {
            background-color: ${theme.colors.tfwBlack99};
            background-image: ${whiteCheckUrl};
            border-color: ${theme.colors.tfwBlack99};
        }
    `,
)

export const SelectText = styled.span<{ $disabled?: boolean }>(
    ({ theme, $disabled }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.small};
        line-height: 1.375rem;
        color: ${theme.colors.tfwBlack99};
        white-space: nowrap;
        opacity: ${$disabled ? 0.4 : 1};
    `,
)

export const SelectChip = styled.label<{ $disabled?: boolean }>(
    ({ theme, $disabled }) => css`
        position: relative;
        display: inline-flex;
        align-items: center;
        gap: ${theme.spacing.xSmall};
        padding: ${theme.spacing.xxSmall} ${theme.spacing.xSmall};
        border: ${theme.typography.border.width.xxxThin} solid ${theme.colors.tfwDefaultInputBorder};
        border-radius: ${theme.typography.border.radius.medium};
        background-color: ${theme.colors.white};
        cursor: ${$disabled ? 'not-allowed' : 'pointer'};
        user-select: none;

        &:hover ${CheckboxTooltip}, &:focus-within ${CheckboxTooltip} {
            opacity: 1;
            visibility: visible;
        }
    `,
)

export const SelectStacked = styled.label<{ $disabled?: boolean }>(
    ({ theme, $disabled }) => css`
        position: relative;
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: ${theme.spacing.xxxSmall};
        background-color: ${theme.colors.white};
        border-radius: ${theme.typography.border.radius.medium};
        cursor: ${$disabled ? 'not-allowed' : 'pointer'};
        user-select: none;
        padding-top: ${theme.spacing.small};

        &:hover ${CheckboxTooltip}, &:focus-within ${CheckboxTooltip} {
            opacity: 1;
            visibility: visible;
        }
    `,
)
